/**
 * Filters out invalid category IDs including "all" and empty values
 * @param categoryIds Array of category IDs to filter
 * @returns Array of valid category IDs
 */
export const filterValidCategoryIds = (categoryIds: string[]): string[] => {
  return categoryIds.filter(
    (id) => id !== "all" && id && typeof id === "string" && id.trim() !== ""
  );
};
